import React from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import { FormButtons, VerificationCodeInput, InputHint, LinkButton, ContentBox, PortalForm } from '@portal/kit/pkg/components'
import SendSmsErrors from 'components/login/send-sms-errors'
import PageTitle from 'components/login/page-title'

const ValidationCodeView = props => (
  <ContentBox title={props.t('portal.reset_password.fill_code')} subTitle={props.t('portal.reset_password.sms_sent')}>
    <PageTitle i18nKey='password_recovery.page_title' />
    <PortalForm onSubmit={props.handleSubmit}>
      <SendSmsErrors resendStatus={props.resendStatus} submitError={props.submitError} />
      <VerificationCodeInput name="code">
        <InputHint>
          {props.t('portal.reset_password.not_received')}
          &nbsp;
          <LinkButton onClick={props.resendCode}>{props.t('portal.reset_password.resend')}</LinkButton>
        </InputHint>
      </VerificationCodeInput>
      <FormButtons submit cancel="/" />
    </PortalForm>
  </ContentBox>
)

ValidationCodeView.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  submitError: PropTypes.string,
  resendCode: PropTypes.func.isRequired,
  resendStatus: PropTypes.string,
  resendStatuses: PropTypes.object.isRequired,
}

export default withTranslation()(ValidationCodeView)
